// React, Next
import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'
import { GlobalContext } from 'context/GlobalContextProvider'

// Img
import MachinesImage from 'public/img/services/endurance_testing_equipment.webp'

// Style
import themeColors from 'assets/theme/colors'
import breakpoints from 'assets/theme/breakpoints'

export default function MachinesSection() {
  const { t } = useTranslation('servicesTestEquipmentModernization')
  const { screenDimensions } = useContext(GlobalContext)

  const stacked = screenDimensions.width < breakpoints.desktopToMobile

  const items = [
    t('machines.items.01'),
    t('machines.items.02'),
    t('machines.items.03'),
    t('machines.items.04'),
    t('machines.items.05'),
    t('machines.items.06')
  ]

  const getContent = () => (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: stacked ? '1fr' : '1fr 1fr',
        gap: stacked ? '2rem' : '3rem',
        alignItems: 'stretch',
        width: '100%'
      }}
    >
      <Box>
        <SectionHeader
          eyebrow={t('machines.eyebrow')}
          title={t('machines.title')}
          intro={[t('machines.intro')]}
        />

        <BulletGrid items={items} columns={2} />
      </Box>

      <Box
        sx={{
          position: 'relative',
          borderRadius: '10px',
          overflow: 'hidden',
          minHeight: stacked ? '16rem' : '100%',
          order: stacked ? -1 : 0
        }}
      >
        <Image
          src={MachinesImage}
          alt="Endurance testing equipment in a test laboratory"
          fill
          sizes="(max-width: 990px) 100vw, 48vw"
          style={{ objectFit: 'cover', objectPosition: 'center' }}
        />
      </Box>
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
